export const UPLOAD = "upload";
export const DIVIDEND_FEED = "dividend-feed";
export const GENERAL = "general";
export const TRADING_HOURS = "trading-hours";
export const LEGAL_DOCUMENTS = "legal-documents";
export const IMAGE_GENERATOR = "image-generator";
export const EMAIL_IMAGE_GENERATOR = "email-image-generator";
export const YT_THUMBNAIL_CREATOR = "youtube-thumbnail-creator";
